
import { defineComponent, PropType } from "vue";
import { SkillProgress } from "@/types";
import rules from "@/shared/constants/rules";
import { Button, Icon } from "@/shared/ui";

export default defineComponent({
	name: "EditSkill",
	levelCups: rules.LEVEL_CUPS,
	components: {
		Icon,
		Button,
	},
	emits: ["update", "remove", "close"],
	props: {
		skill: {
			type: Object as PropType<SkillProgress>,
			required: true,
		},
	},
	data() {
		return {
			tmpSkill: JSON.parse(JSON.stringify(this.skill)),
		};
	},
	computed: {
		experiencePercent() {
			const percent = (this.tmpSkill.experience / this.cup) * 100;
			return percent > 100 ? 100 : percent;
		},
		cup() {
			return this.$options.levelCups[this.tmpSkill.level - 1];
		},
	},
	methods: {
		close() {
			this.$emit("close");
		},
		remove() {
			this.$emit("remove");
			this.close();
		},
		save() {
			this.$emit("update", this.tmpSkill);
			this.close();
		},
		experienceUpdate(event: MouseEvent) {
			const percent =
				event.offsetX / (event.target as HTMLElement).offsetWidth;
			this.tmpSkill.experience = Math.min(
				this.cup,
				Math.max(0, Math.ceil(this.cup * percent))
			);
		},
		levelUp() {
			this.tmpSkill.level = Math.min(
				Number(this.tmpSkill.level) + 1,
				this.$options.levelCups.length
			);
			this.tmpSkill.experience = 0;
		},
		levelDown() {
			this.tmpSkill.level = Math.max(Number(this.tmpSkill.level) - 1, 1);
			this.tmpSkill.experience = 0;
		},
	},
});
